module.exports = __webpack_public_path__ + "img/apple-store-fr-white.9d51a430.svg";